import { render, staticRenderFns } from "./MoonpayCurrencyList.vue?vue&type=template&id=f68e962e&"
import script from "./MoonpayCurrencyList.vue?vue&type=script&lang=js&"
export * from "./MoonpayCurrencyList.vue?vue&type=script&lang=js&"
import style0 from "./MoonpayCurrencyList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports